module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-download"
  }, [(_vm.weChat) ? _c('img', {
    staticClass: "open",
    attrs: {
      "src": require("../assets/images/open_imgs.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "open",
    attrs: {
      "src": require("../assets/images/app_bg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-list"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/load_t.png")
    },
    on: {
      "click": function($event) {
        return _vm.toApp(0)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/images/load_s.png")
    },
    on: {
      "click": function($event) {
        return _vm.toApp(1)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-878b78c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDownload.vue
// module id = 544
// module chunks = 2